import React from "react";
import "../../pages/style.css";
import { Container } from "react-bootstrap";

const Contactpage = () => {
  return (
    <div className="contactbackground">
      <Container>
        <h1 className="contacthead">Connect With Me</h1>
        <p className="contactpara">
          I am currently actively seeking opportunities for a front-end
          developer role.
          <br /> If there are any vacancies available,
          <br /> please feel free to reach out to me. My inbox is always open.
          <br /> Whether you have any additional questions or simply want to say
          hello,
          <br /> I will make every effort to respond promptly.
        </p>
        <button
          className="contactbtn"
          onClick={() => {
            window.open("https://www.linkedin.com/feed/");
          }}
        >
          Say Hello
        </button>
        <div className="copyright">
          © Copyright 2023
          <hr />
          Designed & Built by <span>Nafees Ahmed</span>
        </div>
      </Container>
    </div>
  );
};

export default Contactpage;
